<template>
  <div
    class="module"
    :id="'u' + module.widgets_id"
    :data-id="module.widgets_id"
    :data-index="module_index"
    :pid="column.widgets_id"
    :rowType="module.rowType"
    :anchor-id="module.data.anchor_id"
    data-make="add_sort"
    :data-name="module.name"
    :data-animation-key="'j-' + module.widgets_id"
    :data-animate-type="module.data.animateType"
    :data-button-lock="module.data.pc_widgets_infor.lockType"
    :style="getStyle"
    @mouseenter="module_hover"
    @mouseleave="module_no_hover"
    @mousedown="module_mousedown"
    @mouseup="module_mouseup"
    @contextmenu.stop="module_contextmenu"
    :data-wait-animation="waitAnimationState"
    @animationend="animationReset"
    v-if="isShow"
    @dblclick.stop="edit_module"
    :_key="module.data.animateObj.animate._key"
    :class="[
      module.name,
      is_sortable ? '' : 'module_disabled_sortable'
    ]"
  >
    <!--<h3 class="module_id_view ">module的id:{{module.widgets_id}},rowType:{{module.rowType}},pid:{{column.widgets_id}}</h3>-->
    <slot name="content"></slot>
    <div class="draggable_icon">
      <i class="el-icon-rank"></i>
      <div class="tips_margin_top my_tips my_tips_style draggable_my_tips"></div>
    </div>
    <span class="line_frame change_size_show_dom">
      <div class="project_handler_line project_handler_line_top">
        <div
          class="project_handler_btn jz_tooltip change_margin_top_btn margin_btn"
          @mousedown="fixed_draggable"
          @mouseup="column_operation_line_hidden"
          data-type="top"
        >
          <div class="tips_margin_top my_tips my_tips_style"></div>
        </div>
      </div>
      <!--左边和右边顶到头了，则这个按钮就不出现了-->
      <div class="project_handler_line project_handler_line_left">
        <div
          class="project_handler_btn jz_tooltip change_margin_left_btn margin_btn"
          v-show="parseFloat(module.data[$store.state.app.view_pattern + '_infor'].marginLeft) > 0 || parseFloat(module.data[$store.state.app.view_pattern + '_infor'].marginRight) > 0"
          @mousedown="fixed_draggable"
          @mouseup="column_operation_line_hidden"
          data-type="left"
        >
          <div class="tips_margin_left my_tips my_tips_style"></div>
        </div>
      </div>

      <div class="project_handler_line project_handler_line_right"></div>

      <div class="project_handler_line project_handler_line_bottom"></div>

      <div
        class="project_handler_right_bottom_btn jz_tooltip change_size_btn"
        @mousedown="column_operation_line_show"
        @mouseup="column_operation_line_hidden"
      ></div>
    </span>

    <div class="tips_size change_size_show_dom">
      <p class="width_num tips"></p>
      <p class="height_num tips"></p>
      <p class="row_height_num tips"></p>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

import {mapState, mapActions} from 'vuex'
import linkData from '@/base/linkData'

export default {
  name: 'basic_module',
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    row1: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      isHover: false,
      leftBtn_isShow: true,
      isNotVisibleInViewport: true, // 是否在动画后不可视过
      animationPlayCount: 0, // 模块动画已执行次数
      isInitOut: false, // 是否已初始化触发过
      waitAnimationState: false
    }
  },
  computed: {
    isPc() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    ...mapState({
      isInitOutList: (state) => state.moduleAnimation.isInitOutList
    }),
    isShow() {
      const name = this.module.name
      const setting = this.$store.state.myRender.common.setting
      if (name === 'basic_navbar') {
        return setting.headerNavRadio
      } else if (name === 'basic_webtitle') {
        return setting.logoTitleRadio
      } else if (name === 'basic_language') {
        return setting.multiLanguageOpen
      } else if(name === 'basic_map'){//百度地图隐藏掉
        return false
      } else {
        return true
      }
    },
    getStyle() {
      return {
        marginTop: this.module.data[
        this.$store.state.app.view_pattern + '_infor'
          ].marginTop,
        marginLeft: this.module.data[
        this.$store.state.app.view_pattern + '_infor'
          ].marginLeft,
        marginRight: this.module.data[
        this.$store.state.app.view_pattern + '_infor'
          ].marginRight,
        marginBottom: this.module.data[
        this.$store.state.app.view_pattern + '_infor'
          ].marginBottom
      }
    },
    is_sortable() { // 这个地方 应该是用来排序的class
      let r = true
      if (
        this.module.name == 'basic_copyright' ||
        this.module.name == 'basic_product_detail' ||
        this.module.name == 'basic_article_info' ||
        this.module.name == 'basic_article_info' /* ||
        this.module.name == 'basic_video_detail' */
        /* || this.module.name === "basic_loginregister"  // 头部的登录注册不能拖动 */
      ) {
        r = false
      } else if (
        (this.module.name == 'basic_product_display' ||
          this.module.name == 'basic_article_·  list' ||
          this.module.name === 'basic_product_detail' /* ||
          this.module.name == 'basic_video_detail' */
        ) &&
        this.module.data.isSystem == 'true'
      ) {
        r = false
      } 

      return r
    }
  },
  watch: {
    'module.data.animateCombObj.animate._key'(val) {
      this.add_animation_list()
    },
    'module.data.animateObj.animate._key'(val) {
      this.add_animation_list()
    }
  },
  mounted() {
    const that = this
    this.templet.module_top_btn(this.module.widgets_id)
    this.templet.module_left_btn(this.module.widgets_id)
    this.templet.module_draggable_icon_btn(this.module.widgets_id)
    this.templet.module_size_btn(this.module)

    // 执行模块动画,amp模式下不执行
    const dom = document.querySelector(
      '[data-animation-key="j-' + this.module.widgets_id + '"]'
    )
    this.add_animation_list(dom)

    this.waitAnimationState =
      ((this.module.data.animateType === 'comb_animation' &&
        this.module.data.animateCombObj.animate._key !== 'none') ||
        (this.module.data.animateType === 'module_animation' &&
          this.getAnimate()._key !== 'none')) &&
      !this.isInitOutList.find((item) => item === this.module.widgets_id) &&
      this.isPc
  },
  methods: {
    ...mapActions({
      recordOutKey: 'moduleAnimation/recordOutKey'
    }),
    module_hover(e) {
      let $target = $(e.target)
      let isBasicRowTab = $target.hasClass('basic_row_tab') || $target.find('.basic_row_tab').length
      if (isBasicRowTab) {
        let $basicRowTab = $target.hasClass('basic_row_tab') ? $target : $target.find('.basic_row_tab')
        $basicRowTab.find('.basic-row-tab').children('.module_edit_btn').css('display', 'block')
      }
      if (!isBasicRowTab) {
        $(e.target).find('.module_edit_btn').css('display', 'block')
      }
      let isInBasicRowTab = $target.parents('.basic_row_tab').length
      if (isInBasicRowTab) {
        $target.parents('.basic_row_tab').find('.basic-row-tab').children('.module_edit_btn').css('display', 'block')
      }
    },
    module_no_hover(e) {
      $(e.target).find('.module_edit_btn').css('display', 'none')
    },
    del_module() {
      const obj = this.templet.find_obj(this.column.widgets_id)
        ? this.templet.find_obj(this.column.widgets_id).target
        : null
      if (obj) {
        obj.children.splice(this.module_index, 1)
      }
    },
    module_mousedown() {
      // 导航等挂件拖拽限制
      if (this.module.name === 'basic_navbar') {
        // 导航只能拖拽在系统栏目中
        this.sort_set_disabled('system_col_sort_modules')
      } else if (this.module.name === 'basic_webtitle') {
        // 网站标题挂件只能在头部排序 
        this.sort_set_disabled('header_col')
      } else if (this.module.name === 'basic_vip_header') {
        this.sort_set_disabled('header_col')
      } else if (this.module.name === 'basic_h1') {
        // H1件只能在中部排序
        this.sort_set_disabled('body_col')
      } else if (this.module.name === 'basic_vip_footer') {
        this.sort_set_disabled('footer_col')
      } else if (this.module.name === 'basic_language') {
        let sort_set_disabled = 'header_col'
        if (this.module.data.listArr.position == 'footer') {
          sort_set_disabled = 'footer_col'
        }
        // 多语言挂件只能在头部或者底部排序
        this.sort_set_disabled(sort_set_disabled)
      } else if (this.module.name === 'basic_zhlanguage') {
        this.sort_set_disabled('header_col')
      } else if (this.module.name === 'basic_loginregister') { //限制拖拽 登录的头部 挂件 只能在自己的通栏内移动
        this.sort_set_disabled('header_row_col')
      }
    },
    sort_set_disabled(class_name) {
      const doms = $('.sort_modules')

      for (let i = 0; i < doms.length; i++) {
        if (!$(doms[i]).hasClass(class_name)) {
          $(doms[i]).sortable({disabled: true})
        }
      }
      //打开开关，用于鼠标抬起判断是否重新打开sort
      this.$store.commit('row/set_sort_disabled', true)
      console.log('限制所有挂件排序')
    },
    module_mouseup() {
      this.templet.open_sort()
    },
    module_contextmenu(e) {
      if (this.module_contextmenu_isShow()) {
        e.preventDefault()
        console.log('row:', this.row)
        console.log('row1:', this.row1)
        this.$store.commit('row_contextmenu_dialog/SET_type', 'module')
        this.$store.commit('row_contextmenu_dialog/SET_isShow', true)
        this.$store.commit(
          'row_contextmenu_dialog/SET_contextmenu_obj',
          this.row1 || this.row
        )
        this.$store.commit(
          'row_contextmenu_dialog/SET_contextmenu_module',
          this.module
        )
        this.$nextTick(() => {
          this.$store.commit(
            'row_contextmenu_dialog/SET_top',
            this.templet.contextmenu_position(e).y
          )
          this.$store.commit(
            'row_contextmenu_dialog/SET_left',
            this.templet.contextmenu_position(e).x
          )
        })
      }
    },
    module_contextmenu_isShow() {
      const is_system = this.module.data.isSystem || this.module.data.is_system

      if (this.module.name == 'basic_h1') {
        return false
      }

      //如果不是系统挂件
      if (is_system != 'true') {
        return true
      } else {
        return this.templet.has_moadule_align(this.module)
      }
    },
    // 检测当前节点是否完全可见
    elementIsVisibleInViewport(el) {
      if (!el) return false

      if (this.$store.state.app.scrollType !== 'normal') {
        let $row = $(el).parents('.layout_row')
        if (!$row.hasClass('fullpage-slide-current')) {
          return false
        }
      }

      if ($(el).parents('.basic-row-tab').length) {
        let $tabPanel = $(el).parents('.tab-panel')
        if (!$tabPanel.hasClass('tab-panel-active')) {
          return false
        }
      }

      const {top, left} = el.getBoundingClientRect()
      const boxTop = 0
      const boxBottom = window.innerHeight
      return top - boxTop >= 0 && top - boxTop <= boxBottom - boxTop
    },
    getAnimate() {
      if (!this.module.data.animateObj.animate) return {}
      return this.module.data.animateObj.animate
    },
    animationReset() {
      const dom = document.querySelector(
        '[data-animation-key="j-' + this.module.widgets_id + '"]'
      )
      dom.style.animation = '0s ease 0s 1 normal none running none'
    },
    animation(dom, sync = true) {
      let time = 300
      if (sync) time = 0
      // 检测是否可见
      if (this.elementIsVisibleInViewport(dom)) {
        // 检测是否为第一次初始化
        if (
          !this.isInitOutList.find((item) => item === this.module.widgets_id) ||
          sync
        ) {
          this.recordOutKey(this.module.widgets_id)
          setTimeout(() => {
            dom.removeAttribute('data-wait-animation')
          }, time)
          // 组合动画
          if (
            this.module.data.animateType === 'comb_animation' &&
            this.animationPlayCount === 0
          ) {
            this.animationPlayCount++
            setTimeout(() => {
              const combDom = document.querySelectorAll(
                '[data-animation-key="j-' +
                this.module.widgets_id +
                '"] [data-comb-dom]'
              )
              combDom.forEach((comb, i) => {
                comb.style.animation = '0s ease 0s 1 normal none running none'
                setTimeout(
                  () =>
                    (comb.style.animation = this.getCombAnimationStyle(
                      this.module.data.animateCombObj,
                      i,
                      combDom
                    ))
                )
              })
            }, time)
          }

          // 模块动画
          if (
            this.module.data.animateType === 'module_animation' &&
            this.isNotVisibleInViewport &&
            (this.getAnimate().trigger === 'many' ||
              (this.getAnimate().trigger === 'single' &&
                this.animationPlayCount === 0))
          ) {
            this.animationPlayCount++
            this.isNotVisibleInViewport = false
            dom.style.animation =
              this.getAnimate().duration +
              's ease ' +
              this.getAnimate().delay +
              's ' +
              (this.getAnimate().loop === 10
                ? 'infinite'
                : (this.getAnimate().loop || 0) + 1) +
              ' normal both running ' +
              this.getAnimate()._key +
              this.directionMap(this.getAnimate().direction)
          }
          // 组合动画
          if (
            this.module.data.animateType === 'comb_animation' &&
            this.animationPlayCount === 0
          ) {
            this.animationPlayCount++
            setTimeout(() => {
              const combDom = document.querySelectorAll(
                '[data-animation-key="j-' +
                this.module.widgets_id +
                '"] [data-comb-dom]'
              )
              combDom.forEach((comb, i) => {
                comb.style.animation = '0s ease 0s 1 normal none running none'
                setTimeout(
                  () =>
                    (comb.style.animation = this.getCombAnimationStyle(
                      this.module.data.animateCombObj,
                      i,
                      combDom
                    ))
                )
              })
            }, time)
          }
          // 模块动画
          if (
            this.module.data.animateType === 'module_animation' &&
            this.isNotVisibleInViewport &&
            (this.getAnimate().trigger === 'many' ||
              (this.getAnimate().trigger === 'single' &&
                this.animationPlayCount === 0))
          ) {
            this.animationPlayCount++
            this.isNotVisibleInViewport = false
            dom.style.animation =
              this.getAnimate().duration +
              's ease ' +
              this.getAnimate().delay +
              's ' +
              (this.getAnimate().loop === 10
                ? 'infinite'
                : (this.getAnimate().loop || 0) + 1) +
              ' normal both running ' +
              this.getAnimate()._key +
              this.directionMap(this.getAnimate().direction)
          }
        }
      } else {
        this.isNotVisibleInViewport = true
      }
    },
    edit_module() {
      let module_name_arr = ['basic_copyright', 'basic_vip_header', 'basic_vip_footer', 'basic_loginregister']
      // if (this.module.name == 'basic_copyright' || this.module.name == 'basic_vip_header' || this.module.name == 'basic_vip_footer' ) {
      if (module_name_arr.indexOf(this.module.name) !== -1) {
        return
      } else if (this.module.name == 'basic_picture') {
        this.change_img()
        return
      } else if (
        this.$store.state.app.view_pattern == 'mb' &&
        (this.module.name == 'basic_text' || this.module.name == 'basic_text_rich_type')
      ) {
        return
      }
      this.templet.changeStyle(this.module)
    },
    change_img() {
      this.$store.commit('image_upload/set_fileType', 1)
      this.$store.commit('image_upload/set_showTag', true)
      this.$store.commit('image_upload/set_fileLimit', 1)
      this.$store.state.image_upload.imgFile = (e) => {
        if (e && e instanceof Array && e.length > 0) {
          this.module.data.listArr.url = e[0].filePath
        }
        this.$store.state.image_upload.imgFile = null
      }
    },
    //顶部fixed的情况下，拖拽会抖动
    fixed_draggable(e) {
      //如果拖拽的时候，按钮是顶部，且顶部是固定的
      const is_header = $(e.target).parents('.layout_header_fixed')
      if (is_header.length > 0) {
        //is_header.addClass('.fixed_draggable');
        const top = $(window).scrollTop()
        const style = $(
          `<style id="one_style">.layout_header_fixed{top:${top}px !important;position:absolute !important;}</style>`
        )
        if ($('#one_style').length == 0) {
          style.appendTo('head')
        }
      }
      this.column_operation_line_show()

      $(e.target).addClass('change_margining')
      this.templet.left_top_margin_tips(
        $(e.target),
        $(e.target).attr('data-type')
      )
    },
    column_operation_line_show() {
      $(`#u${this.module.widgets_id}`).addClass('moving')
      $(`#u${this.row.widgets_id}`)
        .find('.column_operation_line')
        .addClass('column_operation_line_show')
    },
    column_operation_line_hidden(e) {
      $(`#u${this.module.widgets_id}`).removeClass('moving')
      $(`#u${this.row.widgets_id}`)
        .find('.column_operation_line')
        .removeClass('column_operation_line_show')
      $(e.target).removeClass('change_margining')
    },
    add_animation_list(dom) {
      const module_data = this.module.data
      if (
        module_data.animateCombObj &&
        module_data.animateObj &&
        module_data.animateCombObj.animate._key == 'none' &&
        module_data.animateObj.animate._key == 'none'
      ) {
        return
      }
      //this.animation(dom, false);
      this.at_once_animate(dom)
      const implement = this.$store.state.moduleAnimation.implement
      let is_have = false
      for (let i = 0; i < implement.length; i++) {
        if (implement[i].module.widgets_id == this.module.widgets_id) {
          is_have = true
          break
        }
      }
      if (!is_have) {
        implement.push({
          module: this.module,
          //animation: this.animation,
          vue: this
        })
        //implement.push(this)
      }
      //console.log(implement)
    },
    at_once_animate(dom) {
      //横幅中的module，除了第一页以外，不触发动画
      if ($(dom).parents('.full_screen_banner').length > 0) {
        if ($(dom).parents('.swiper-slide').index() != 0) {
          setTimeout(() => {// 里面的挂件不显示了
            dom.removeAttribute('data-wait-animation')
          }, 500);
          return
        }
      }

      this.animation(dom, false)
    }
  }
}
</script>

<style scoped lang="scss">
[data-wait-animation] {
  opacity: 0;
}

.tips_size {
  display: none;
  padding: 2px 8px;
  border: 1px solid #f5e4b9;
  font-size: 13px;
  line-height: 21px;
  color: #333;
  background-color: #fffaee;
  border-radius: 2px;
  position: absolute;
  z-index: 9999;

  .tips {
    white-space: nowrap;
    word-break: normal;
    height: 20px;
    font-weight: normal;
    color: #333;
    font-size: 13px;
    margin-bottom: 0;
  }
}

.top_left {
  bottom: 5px;
  right: 5px;
  top: auto;
  left: auto;
}

.bottom_left {
  top: calc(100% + 5px);
  right: 5px;
  bottom: auto;
  left: auto;
}

.top_right {
  bottom: 5px;
  left: calc(100% + 5px);
  top: auto;
  right: auto;
}

.bottom_right {
  top: calc(100% + 5px);
  left: calc(100% + 5px);
  right: auto;
  bottom: auto;
}

.tips_size_touch_bottom {
  top: auto !important;
  bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_module/index.vue